import React, { Suspense } from 'react';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import UILoader from 'components/UI/Loader/Loader';

const BrandSpotlight = React.lazy(
  () => import('components/Tools/BrandSpotlight/BrandSpotlight'),
);

function ScreensToolsBrandSpotlight() {
  return (
    <BaseLayout>
      <DocumentTitle>Brand Spotlight Move</DocumentTitle>
      <UIPageTitle description="Move spotlight entries between brands">
        Brand Spotlight Move
      </UIPageTitle>
      <Suspense fallback={<UILoader />}>
        <BrandSpotlight />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensToolsBrandSpotlight;
